/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Pricing_Feat3Inputs */

const en_st_pricing_feat3 = /** @type {(inputs: St_Pricing_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client progress page with evidence`)
};

const id_st_pricing_feat3 = /** @type {(inputs: St_Pricing_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman progres klien dengan bukti`)
};

/**
* | output |
* | --- |
* | "Client progress page with evidence" |
*
* @param {St_Pricing_Feat3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_pricing_feat3 = /** @type {((inputs?: St_Pricing_Feat3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Pricing_Feat3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_pricing_feat3(inputs)
	return en_st_pricing_feat3(inputs)
});